

import RequestAbstract from "../abstract";

export default class WalletPinCodes extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/pin-codes";
    }
}

